import React from 'react';
import { colors } from 'design-system';
import VectorIcon from './VectorIcon';

type Props = {
  width?: number;
  height?: number;
};

const InspectionSentIcon = ({
  width = 56,
  height = 56,
}: Props): JSX.Element => (
  <VectorIcon width={width} height={height}>
    <circle
      cx="28"
      cy="28"
      r="26"
      fill="#0D2E68"
      stroke="url(#paint0_linear_11781:41905)"
      strokeWidth="4"
    />
    <circle cx="28" cy="27" r="12" fill="white" />
    <path
      d="M33.7046 24.7644C34.0985 24.3609 34.0985 23.7066 33.7046 23.3029C33.311 
      22.8994 32.6726 22.8994 32.2788 23.3029L26.228 29.5054L23.721 26.9357C23.3274 
      26.532 22.689 26.532 22.2954 26.9357C21.9015 27.3392 21.9015 27.9936 22.2954 
      28.397L25.5151 31.6976C25.909 32.1011 26.5472 32.1011 26.941 31.6976L33.7046 24.7644Z"
      fill="#0D2E68"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11781:41905"
        x1="28"
        y1="4"
        x2="28"
        y2="52"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={colors.bright_turquoise} />
        <stop offset="1" stopColor="#CEE8FF" />
      </linearGradient>
    </defs>
  </VectorIcon>
);

export default InspectionSentIcon;
